// eslint-disable-next-line import/no-duplicates
import { parseISO } from 'date-fns';
import { format } from 'date-fns-tz';
// eslint-disable-next-line import/no-duplicates
import { pt } from 'date-fns/locale';

export const formatDateString = (date: string): string => {
  return format(parseISO(date), "dd 'de' MMM yyyy", {
    locale: pt,
    timeZone: 'UTC'
  });
};

export const nominativeMonthName = (date: string): string => {
  return format(new Date(date), 'LLLL', { locale: pt }).toLowerCase() ?? '';
};
